// Toast - 简单一行提示
// v1.9 P0: 用 Alert base + 固定定位 (mobile 全宽, desktop 右下角)
// 用法: <Toast kind="success" message="已保存" /> 或包到 store 里动态显示
import { useEffect } from 'react';
import { Icon } from './Icon';
import { Alert, type AlertVariant } from './ui/Alert';

interface ToastProps {
  kind: 'success' | 'error' | 'info' | 'warning';
  message: string;
  duration?: number;
  onClose?: () => void;
}

const ICON_FOR: Record<ToastProps['kind'], string> = {
  success: 'check-circle-2',
  error: 'alert-triangle',
  info: 'info',
  warning: 'alert-triangle',
};

const ALERT_VARIANT: Record<ToastProps['kind'], AlertVariant> = {
  success: 'success',
  error: 'error',
  info: 'info',
  warning: 'warning',
};

export function Toast({ kind, message, duration = 2500, onClose }: ToastProps) {
  useEffect(() => {
    if (!onClose) return;
    const t = setTimeout(onClose, duration);
    return () => clearTimeout(t);
  }, [onClose, duration]);

  return (
    <div
      className="fixed inset-x-3 bottom-4 sm:left-auto sm:right-4 sm:inset-x-auto z-50 sm:max-w-sm animate-fade-up"
      role="presentation"
    >
      <Alert
        variant={ALERT_VARIANT[kind]}
        // biome-ignore lint/a11y/useSemanticElements: Alert 内部已用 <output>/<div role="alert"> 分发, 这里 role 决定渲染哪种
        role="status"
        icon={ICON_FOR[kind]}
        dismissible={!!onClose}
        onDismiss={onClose}
      >
        <span className="flex items-center gap-2">
          <Icon name={ICON_FOR[kind]} size="sm" aria-hidden />
          {message}
        </span>
      </Alert>
    </div>
  );
}
